import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { enqueueSnackbar } from 'actions';
import clsx from 'clsx';
import moment from 'moment';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Tabs, Tab, Typography, Box, Divider } from '@mui/material';
import _ from 'underscore';
import { SelectField } from 'components';
import { MultiSelectField } from 'components/SelectField';
import DatePicker from 'components/DatePicker/DatePicker';
import DateTimePicker from 'components/DatePicker/DateTimePicker';
import TimePicker from 'components/DatePicker/TimePicker';

import { SetFormState, GetClusterString } from '../../actions/HostToolsActions';

const useStyles = makeStyles(theme => ({
	root: {},
}));

const ClusterStringDialogForm = (props) => {
	const { className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const [availableDates, setAvailableDates] = useState([]);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.hostToolsReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const userRole = useSelector(state => state.session.user.role);
	const clustersInfo = useSelector((state) => state.hostToolsReducer.clustersInfo);

	const _handleChange = event => {
		if (event.target.name === 'selectedHost') {
			const filtered = clustersInfo.mocnActivationDatesF
				.filter(d => d.extra === event.target.value)
				.map(d => ({ value: d.value, text: d.text }));
			setAvailableDates(filtered);
		}
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});
	};
	
	const _handleListChange = value => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				'selectedActivationDates': value
			},
			touched: {
				...formState.touched,
				'selectedActivationDates': true
			}
		});
	};

	const _exportData = () => {
		dispatch(GetClusterString(userId, formState.values.selectedActivationDates, formState.values.selectedHost));
	};

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card>
						<CardHeader title="Cluster String" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item spacing={2} md={6} xs={6} style={{ display: 'inline-flex', justifyContent: 'space-between', gap: '10px' }}>
									<SelectField
										id="selectedHost"
										name="selectedHost"
										hintText="HOST"
										defaultValue=""
										menuItems={(clustersInfo.hosts) || []}
										value={formState.values.selectedHost}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
									/>
									<MultiSelectField
										id="selectedActivationDates"
										name="selectedActivationDates"
										hintText="MOCN Activation Dates (F)"
										menuItems={availableDates || []}
										value={formState.values.selectedActivationDates}
										onListChange={_handleListChange}
										disabled={formState.values.selectedHost === undefined}
										renderValue={(selected) => selected.map(d => new Date(d).toLocaleDateString("en-GB")).join(', ')}
									/>
								</Grid>
								{/* <Grid item md={3} xs={3}>
									<SelectField
										id="clusterName"
										name="clusterName"
										hintText="Cluster Name"
										defaultValue=""
										menuItems={(clustersInfo.mocnActivationDateF) || []}
										value={formState.values.clusterName}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={formState.values.host === undefined}
									/>
								</Grid> */}
								<Grid item md={2} xs={2}>
									<Button
										onClick={_exportData}
										color="secondary"
										size="small"
										variant="contained"
										style={{ height: '100%' }}
										disabled={!(
											formState.values.selectedHost &&
											formState.values.selectedActivationDates &&
											formState.values.selectedActivationDates.length > 0
										)}
									>
										Export Data
									</Button>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div >
	);
};

ClusterStringDialogForm.propTypes = {
	className: PropTypes.string
};

export default ClusterStringDialogForm;
